import { useQuery } from '@tanstack/react-query';

import { fetchResetPasswordExpiration } from '../../api/lib/auth';
import { resetPasswordExpirationKeys } from '../../api/query-keys/reset-password-expiration';

export const useResetPasswordExpiration = (token: string, enabled = true) => {
  return useQuery({
    queryFn: () => fetchResetPasswordExpiration(token),
    queryKey: resetPasswordExpirationKeys.detail(token),
    enabled,
  });
};
